/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanChangeRequest
 */
export interface PlanChangeRequest {
    /**
     * The proration_date returned by the preview, so the charge matches what staff confirmed
     * @type {number}
     * @memberof PlanChangeRequest
     */
    proration_date: number;
}

/**
 * Check if a given object implements the PlanChangeRequest interface.
 */
export function instanceOfPlanChangeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proration_date" in value;

    return isInstance;
}

export function PlanChangeRequestFromJSON(json: any): PlanChangeRequest {
    return PlanChangeRequestFromJSONTyped(json, false);
}

export function PlanChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanChangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proration_date': json['proration_date'],
    };
}

export function PlanChangeRequestToJSON(value?: PlanChangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'proration_date': value.proration_date,
    };
}

